import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-membership-mark",
  "use": "icon-membership-mark-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-membership-mark\">\n    <circle cx=\"6\" cy=\"6\" r=\"6\" fill=\"var(--ob-mm-bg-color)\" />\n    <circle cx=\"6\" cy=\"6\" r=\"2\" fill=\"var(--ob-mm-color)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol